import { apiFetch } from '@/lib/apiFetch'

export interface EulaDocument {
  version: string
  sha256: string
  content: string
}

export interface EulaStatus {
  version: string
  sha256: string
  accepted: boolean
  accepted_at: string | null
}

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers || {})
  if (init?.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json')
  const res = await apiFetch(url, { ...init, headers })
  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error(body?.detail || `Request failed with status ${res.status}`)
  }
  return res.json()
}

export const legalApi = {
  /** Public — works pre-auth (register page, /legal/eula). */
  getEula: () => request<EulaDocument>('/api/legal/eula'),
  /** Authenticated — has the current user accepted the current text? */
  getStatus: () => request<EulaStatus>('/api/legal/eula/status'),
  /** Authenticated — record clickwrap acceptance of the text the user saw. */
  accept: (sha256: string) =>
    request<EulaStatus>('/api/legal/eula/accept', {
      method: 'POST',
      body: JSON.stringify({ sha256 }),
    }),
}
